import { createSlice } from '@reduxjs/toolkit';

const sidePanelStore = createSlice({
  name: 'sidePanel',
  initialState: {},
  reducers: {
    setData: (state, { payload }) => {
      state = state ? { ...state, ...payload } : { ...payload };
      return state;
    },
  },
});

export const sidePanelActions = sidePanelStore.actions;

export default sidePanelStore.reducer;
